<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="姓名:"
                      prop="name">
          <el-input v-model.trim="searchForm.name"
                    placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="类别:"
                      prop="type">
          <el-input v-model.trim="searchForm.type"
                    placeholder="类别"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData">
        <el-table-column type="index"
                         label="序号"
                         width="60"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="210">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="primary"
                       @click="handleLost(scope.row)">挂失</el-button>
            <el-button plain
                       size="mini"
                       type="success"
                       @click="handleUnlost(scope.row)">解挂</el-button>
            <el-button size="mini"
                       type="danger"
                       @click="handleDestory(scope.row)">注销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination },
  data() {
    return {
      searchForm: {
        name: '',
        type: ''
      },
      tableTitle: [
        {
          prop: 'person',
          name: '人员',
          width: '100'
        },
        {
          prop: 'user_type',
          name: '类别',
          width: '80'
        },
        {
          prop: 'building',
          name: '机构',
          width: '120'
        },
        {
          prop: 'room',
          name: '房间',
          width: '120'
        },
        {
          prop: 'time',
          name: '时间',
          width: '120'
        },
        {
          prop: 'way',
          name: '方式',
          width: '80'
        }
      ],
      tableData: [
        {
          room: '静园3楼301室',
          person: '小车',
          user_type: '学生',
          building: '2020级计算机系',
          time: '2020-09-09 08:00:12',
          way: 'IC卡'
        },
        {
          room: '静园3楼301室',
          person: '小车',
          user_type: '学生',
          building: '2020级计算机系',
          time: '2020-09-09 08:00:12',
          way: 'IC卡'
        },
        {
          room: '静园3楼301室',
          person: '小车',
          user_type: '学生',
          building: '2020级计算机系',
          time: '2020-09-09 08:00:12',
          way: 'IC卡'
        }
      ],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加维修相关
      showRepairModal: false,
      repairData: {
        type: 'add'
      },
      // 维修记录相关
      showDealModal: false,
      dealData: {
        id: -1
      }
    }
  },
  methods: {
    // 获取列表
    getList() {
      // let start = (this.pagination.currentPage - 1) * this.pagination.perPage
      // fetch
      //   .getStaffList({
      //     start: start,
      //     limit: this.pagination.perPage,
      //     ...this.searchForm
      //   })
      //   .then((data) => {
      //     data.procData(
      //       data.res,
      //       (data) => {
      //         this.pagination.total = data.count
      //         this.tableData = data.result
      //       },
      //       (err) => {
      //         this.$message.error(err)
      //       }
      //     )
      //   })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    handleLost(data) {
      this.$confirm('是否确定挂失该卡片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(data.id)
        })
        .catch(() => {})
    },
    handleUnlost(data) {
      this.$confirm('是否确定解除挂失该卡片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(data.id)
        })
        .catch(() => {})
    },
    handleDestory(data) {
      this.$confirm('是否确定注销该卡片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(data.id)
        })
        .catch(() => {})
    }
  }
}
</script>

<style></style>
